import React from "react";
import ProgressSetup from "./ProgressSetup";
import SetupGuide from "./SetupGuide";
import { MdOutlineRocketLaunch } from "react-icons/md";

const Welcome = ({ step = 0, totalSteps = 4, nextStep = () => { } }) => {
    const title = "Bem vindo(a) a Oktto!"
    const description = "Em poucos passos, vamos preparar sua operação e mostrar os caminhos essenciais para você começar com segurança."
    const btnText = "Iniciar configuração"

    return (
        <ProgressSetup
            step={step}
            totalSteps={totalSteps}
            title={title}
            description={description}
            btnText={btnText}
            onClick={nextStep}
        >
            <SetupGuide
                icon={<MdOutlineRocketLaunch />}
                title="Uma base pronta para sua equipe trabalhar"
                items={[
                    { title: "Organize seu processo", description: "Crie o funil e as etapas que representam o caminho de uma oportunidade." },
                    { title: "Padronize informações", description: "Defina motivos de descarte e os produtos que sua empresa oferece." },
                    { title: "Conecte e pratique", description: "Conheça as integrações do seu plano e realize as primeiras ações guiadas." },
                ]}
                note="Você poderá revisar e alterar todas essas configurações depois."
            />
        </ProgressSetup>
    )
}

export default Welcome
